import React from "react";
import { formatInvoiceMoney } from "../../utilis/invoiceLineItemHelpers";

function InvoiceEditSummaryPanel({
  currency = "AUD",
  totalAmount = 0,
  discountAmount = 0,
  paidAmount = 0,
  amountDue = 0,
  showDiscount = true,
}) {
  const total = Math.max(Number(totalAmount) || 0, 0);
  const discount = Math.max(Number(discountAmount) || 0, 0);
  const paid = Math.max(Number(paidAmount) || 0, 0);
  const remaining = Math.max(Number(amountDue) || 0, 0);
  const hasPayment = paid > 0;

  const formatValue = (value) => formatInvoiceMoney(value, currency, {});

  return (
    <section className="invoice-edit-summary">
      <div className="invoice-edit-summary__header">
        <h3 className="invoice-edit-summary__title mb-0">Invoice summary</h3>
      </div>
      <div className="invoice-edit-summary__body">
        <div
          className={`invoice-edit-summary__grid${
            showDiscount ? "" : " invoice-edit-summary__grid--no-discount"
          }`}
        >
          <div className="invoice-edit-summary__item">
            <span className="invoice-edit-summary__label">Total</span>
            <strong className="invoice-edit-summary__value">
              {formatValue(total)}
            </strong>
          </div>
          {showDiscount ? (
            <div className="invoice-edit-summary__item invoice-edit-summary__item--discount">
              <span className="invoice-edit-summary__label">Discount</span>
              <strong className="invoice-edit-summary__value">
                {discount > 0 ? `-${formatValue(discount)}` : formatValue(0)}
              </strong>
            </div>
          ) : null}
          {hasPayment ? (
            <div className="invoice-edit-summary__item invoice-edit-summary__item--paid">
              <span className="invoice-edit-summary__label">Less paid</span>
              <strong className="invoice-edit-summary__value">
                {formatValue(paid)}
              </strong>
            </div>
          ) : null}
          <div className="invoice-edit-summary__item invoice-edit-summary__item--due">
            <span className="invoice-edit-summary__label">
              {hasPayment ? "Amount due" : "Remaining"}
            </span>
            <strong className="invoice-edit-summary__value">
              {formatValue(remaining)}
            </strong>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InvoiceEditSummaryPanel;
